import * as React from 'react';
import { SVGProps } from 'react';

const IconDownSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 4v12.17l-5.59-5.59L4 12l8 8 8-8-1.41-1.41L13 16.17V4h-2Z" />
  </svg>
);
export default IconDownSizeM;
